// @flow

import PdbCompare from './popup/pdbCompare.container';
import CompareTable from './compareTable/compareTable.container';
import TechSpecs from './techSpecs/techSpecs.container';

export {
  CompareTable,
  TechSpecs,
};

export default PdbCompare;
